var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E4DF69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2273 8.25H13.4545V6H5.18182C4.53182 6 4 6.50625 4 7.125V13.3125H5.18182C5.18182 14.2463 5.97364 15 6.95455 15C7.93545 15 8.72727 14.2463 8.72727 13.3125H12.2727C12.2727 14.2463 13.0645 15 14.0455 15C15.0264 15 15.8182 14.2463 15.8182 13.3125H17V10.5L15.2273 8.25ZM14.9318 9.09375L16.09 10.5H13.4545V9.09375H14.9318ZM6.95455 13.875C6.62955 13.875 6.36364 13.6219 6.36364 13.3125C6.36364 13.0031 6.62955 12.75 6.95455 12.75C7.27955 12.75 7.54545 13.0031 7.54545 13.3125C7.54545 13.6219 7.27955 13.875 6.95455 13.875ZM8.26636 12.1875C7.94136 11.8444 7.48045 11.625 6.95455 11.625C6.42864 11.625 5.96773 11.8444 5.64273 12.1875H5.18182V7.125H12.2727V12.1875H8.26636ZM14.0455 13.875C13.7205 13.875 13.4545 13.6219 13.4545 13.3125C13.4545 13.0031 13.7205 12.75 14.0455 12.75C14.3705 12.75 14.6364 13.0031 14.6364 13.3125C14.6364 13.6219 14.3705 13.875 14.0455 13.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.b7278c97da020d2e3cc3b6c567fe9a5f.svg";
export { ForwardRef as ReactComponent };